export const Home = () => {
  // Intentionally empty.
  // Organization selection & redirects are handled in Layout.
  return null;
};
